<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!--todo:开启缓存后，存在问题（目前不再出现该问题）-->
      <keep-alive :include="cachedViews">
        <router-view/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
    export default {
        name: 'AppMain',
        computed: {
            cachedViews() {
                console.log("是否要缓存："+this.$store.state.tagsView.cachedViews);
                return this.$store.state.tagsView.cachedViews
            },
            key() {
                return this.$route.path
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
  .app-main {
    /* 50= navbar  50  */
    min-height: calc(100vh);
    height: auto;
    /*width: 100%;*/
    position: relative;
    /*overflow: hidden;*/
    background-color: #f0f2f5;
  }

  .fixed-header+.app-main {
    padding-top: 50px;
  }

  .hasTagsView {
    .app-main {
      /* 84 = navbar + tags-view = 50 + 34 */
      min-height: calc(100vh);
    }

    .fixed-header+.app-main {
      padding-top: 84px;
    }
  }
</style>

<style type="text/scss" lang="scss">
  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue